import { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import TopupModal from "./components/TopupModal";
import TopupTable from "./components/TopupTable";
import transactionData from "./data";

const Topup = () => {
  const topupMethods = [
    {
      id: "qr",
      title: "via QR Code",
      subTitle: "PayNow QR",
      description: "Scan QR code with your banking app",
      icon: "fas fa-qrcode",
      bgColor: "#eef2ff",
      iconColor: "#4f46e5",
    },
    {
      id: "uen",
      title: "via UEN",
      subTitle: "PayNow via UEN",
      description: "Use UEN number for payment",
      icon: "fas fa-building",
      bgColor: "#ecfdf5",
      iconColor: "#10b981",
    },
    {
      id: "bank",
      title: "Bank transfer",
      subTitle: "Bank transfer",
      description: "Transfer from your bank account",
      icon: "fas fa-credit-card",
      bgColor: "#f5f3ff",
      iconColor: "#8b5cf6",
    },
    {
      id: "atm",
      title: "ATM funds transfer",
      subTitle: "ATM transfer",
      description: "Transfer funds via ATM",
      icon: "fas fa-university",
      bgColor: "#fffbeb",
      iconColor: "#f59e0b",
    },
  ];

  const currencies = [
    {
      code: "SGD",
      name: "Singapore Dollar",
      flag: "https://flagcdn.com/w40/sg.png",
    },
    {
      code: "USD",
      name: "US Dollar",
      flag: "https://flagcdn.com/w40/us.png",
    },
  ];

  const [transactions, setTransactions] = useState(transactionData);
  const [showModal, setShowModal] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [amount, setAmount] = useState();
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);

  const handleMethodClick = (method) => {
    setSelectedMethod(method);
    setShowModal(true);
    setAmount("");
  };

  const handleConfirm = () => {
    const newTransaction = {
      id: `TU${Math.floor(5200 + Math.random() * 1000)}`,
      uniqueId: `UP${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
      createdTime: new Date()
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(",", ""),
      type: selectedMethod?.subTitle || "Topup",
      customer: { name: "thuynga02", email: "thuynga02@yopmail.com" },
      amount: `${amount} ${selectedCurrency.code}`,
      status: "Pending",
    };

    setTransactions([newTransaction, ...transactions]);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-black mb-0">Topup</h2>
      </div>

      <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-5">
        <Card.Body className="p-4 pb-2">
          <h5 className="fw-bold text-black mb-4 fs-16">Select topup method</h5>
          <Row>
            {topupMethods.map((method) => (
              <Col xl={6} lg={6} md={12} key={method.id} className="mb-4">
                <div
                  className="topup-method-card d-flex align-items-center p-3 border rounded-4 cursor-pointer transition-all hover-shadow"
                  style={{ borderColor: "#f1f1f1" }}
                  onClick={() => handleMethodClick(method)}
                >
                  <div
                    className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle me-3"
                    style={{
                      backgroundColor: method.bgColor,
                      width: "56px",
                      height: "56px",
                      minWidth: "56px",
                    }}
                  >
                    <i
                      className={`${method.icon} fs-20`}
                      style={{ color: method.iconColor }}
                    ></i>
                  </div>
                  <div>
                    <h6 className="fw-bold text-black mb-1 fs-15">
                      {method.title}
                    </h6>
                    <p className="text-muted mb-0 fs-13">
                      {method.description}
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>

      <TopupTable data={transactions} />

      <TopupModal
        show={showModal}
        onHide={() => setShowModal(false)}
        selectedMethod={selectedMethod}
        amount={amount}
        setAmount={setAmount}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        currencies={currencies}
        handleConfirm={handleConfirm}
      />

      <style>{`
        .transition-all {
          transition: all 0.2s ease-in-out;
        }
        .hover-shadow:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          border-color: var(--primary) !important;
          transform: translateY(-2px);
        }
        .cursor-pointer {
          cursor: pointer;
        }
        .fs-13 { font-size: 13px; }
        .fs-15 { font-size: 15px; }
        .fs-16 { font-size: 16px; }
        .fs-20 { font-size: 20px; }
      `}</style>
    </div>
  );
};

export default Topup;
